import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const QuestionIcon = observer('QuestionIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM9.35061 7.13415C10.0178 6.46691 10.9366 6.1333 12.107 6.1333C13.2118 6.1333 14.0814 6.38488 14.7158 6.88804C15.3502 7.3912 15.6674 8.0967 15.6674 9.00458C15.6674 9.58431 15.5362 10.0656 15.2736 10.4484C15.0111 10.8313 14.6283 11.2414 14.1251 11.679C13.6876 12.0727 13.3649 12.4146 13.1571 12.7044C12.9493 12.9943 12.8454 13.3416 12.8454 13.7463H10.6632C10.6632 13.3088 10.7261 12.9259 10.8519 12.5978C10.9777 12.2696 11.1308 11.9989 11.3113 11.7856C11.4918 11.5723 11.7242 11.3289 12.0086 11.0555C12.3258 10.7602 12.561 10.5004 12.7141 10.2761C12.8672 10.0519 12.9438 9.78666 12.9438 9.48039C12.9438 8.81316 12.5719 8.47955 11.8281 8.47955C11.0077 8.47955 10.5921 8.96629 10.5812 9.93979L8.33335 9.92339C8.34429 8.73112 8.68337 7.80138 9.35061 7.13415ZM12.714 15.3706C12.9765 15.6332 13.1078 15.9722 13.1078 16.3879C13.1078 16.8035 12.9765 17.1454 12.714 17.4134C12.4515 17.6813 12.1124 17.8153 11.6968 17.8153C11.2921 17.8153 10.9584 17.6813 10.6959 17.4134C10.4334 17.1454 10.3022 16.8035 10.3022 16.3879C10.3022 15.9722 10.4307 15.6332 10.6877 15.3706C10.9448 15.1081 11.2811 14.9769 11.6968 14.9769C12.1124 14.9769 12.4515 15.1081 12.714 15.3706Z'
                fill='fill'
            />
        </SvgElement>
    );
});
